import React, { useState, useEffect } from 'react';
import { Handle, Position } from 'reactflow';
import '../Node_Edge_Components.css';
import NodeIcons from './Node_Icons';

const SubFlowNode = ({ data, id, }) => {
  const [nodeColor, setNodeColor] = useState(data.color);
  const [iconDisplay, setIconDisplay] = useState(false);

  useEffect(() => {
    setIconDisplay(data.showIcons || false);
  }, [data.showIcons]);

  useEffect(() => {
    setNodeColor(data.color);
  }, [data.label, data.color, data.fontColor, data.fontSize, data.fontStyle]);

  const handleStyles = {
    background: "#757ea5",
    height: "4px",
    width: "4px",
  };
  const iconDisplayClose = () => {
    setIconDisplay(false);
  }

  return (
    <>
      <Handle type='target' position="top" id={`${id}-top-target`} style={handleStyles} />
      <Handle type='source' position="bottom" id={`${id}-bottom-source`} style={handleStyles} />

      <div className='subFlow node' >
        <div className='subFlowOuter subflowInnner' style={{ backgroundColor: nodeColor, }}>
          <p style={{ color: "#757EA5" }}>{data.level}</p>
        </div>

        
          <NodeIcons
            onDelete={() => data.onDelete(id)}
            nodeIconsClose={iconDisplayClose}
            fromWorkflow={true}
            onPropertiesTabClose={() => data.onPropertiesTabClose()}
          />
         
      </div>
    </>
  )
}
export default SubFlowNode;